import React, { ReactNode, useRef, useState } from 'react';
import { OverlayPanel } from 'primereact/overlaypanel';
import { FormicaSelectBoxItem } from './custom/FormicaSearchSelectBox';
import CustomCheckBox from './custom/CustomCheckBox';
import FormicaInput from './custom/FormicaInput';
import Icon from '../icons/Icon';
import LanguageUtil from '../util/LanguageUtil';

function TableColumnPreferencesComponent(props: Props) {
  const ref = useRef<OverlayPanel>(null);
  const [search, setSearch] = useState<string>('');
  const { items } = props;

  const toggleSelected = (item: FormicaSelectBoxItem) => {
    const isAll = item.value == '__*all*__';
    const isAllSelected = items.every((item) => props.selectedItems?.find((selectedItem) => selectedItem.value == item.value) != undefined);
    const isSelected = props.selectedItems.find((selectedItem) => selectedItem.value == item.value);
    if (isAll) {
      if (isAllSelected) {
        props.onChangeSelectedItems([]);
      } else {
        props.onChangeSelectedItems(items);
      }
      return;
    }
    if (isSelected) {
      props.onChangeSelectedItems(props.selectedItems?.filter((selectedItem) => selectedItem.value != item.value) as FormicaSelectBoxItem[]);
    } else {
      props.onChangeSelectedItems([...(props.selectedItems || []), item]);
    }
  };

  const getItems = (): ReactNode => {
    const filteredItems = items?.filter((item) => {
      return item.label.toLowerCase().includes(search.toLowerCase());
    });
    if (!filteredItems || filteredItems?.length == 0) {
      return (
        <div className={'flex items-center justify-start w-full h-full text-f-black-2 text-md'}>
          {LanguageUtil.get({ id: 'common.label.notFound', defaultMessage: 'Not Found' })}
        </div>
      );
    }
    return filteredItems.map((item, index) => getItem(item, index));
  };

  const getItem = (item: FormicaSelectBoxItem, index: number) => {
    const isAllSelected = items.every((item) => props.selectedItems?.find((selectedItem) => selectedItem.value == item.value) != undefined);
    const isSelected = isAllSelected || props.selectedItems?.find((selectedItem) => selectedItem.value == item.value);
    return (
      <div
        key={index}
        onClick={() => {
          toggleSelected(item);
        }}
        className={`flex w-full text-sm text-f-black-2 cursor-pointer h-[40px] min-h-[40px] items-center hover:text-f-purple justify-start gap-x-2 px-3 py-2 hover:bg-[#F7F8FA]`}
      >
        <CustomCheckBox
          checked={isSelected != undefined}
          onChangeChecked={() => {
            if (item.value == '__all__') {
            }
            toggleSelected(item);
          }}
        />
        {item.label}
      </div>
    );
  };

  return (
    <div className={'flex items-center justify-end'}>
      {props.containerNode ? (
        props.containerNode((event: React.MouseEvent) => ref.current?.toggle(event))
      ) : (
        <a
          className={
            'flex hover:fill-primary items-center justify-center relative group bg-white-1 border rounded min-w-[28px] h-[28px] hover:bg-f-gray active:bg-[#458EF714] active:border-[#458EF7]'
          }
          onClick={(event: React.MouseEvent) => ref.current?.toggle(event)}
        >
          <Icon icon={'preferences'} size={24} color={'#4F4F4F'} className={'hover:text-primary hover:cursor-pointer'} />
          <div className={'z-50 -bottom-8 rounded absolute hidden px-[10px] py-[2px] text-2xs text-white bg-primary group-hover:flex'}>
            {LanguageUtil.get({ id: 'common.label.column', defaultMessage: 'Column' })}
            {LanguageUtil.get({ id: 'common.label.cPreferences', defaultMessage: 'Preferences' })}
          </div>
        </a>
      )}
      <OverlayPanel ref={ref}>
        <div className={'flex flex-col items-center overflow-hidden justify-start min-h-[300px] max-h-[300px] w-[280px]'}>
          <div className={'flex w-full  shrink-0 items-center h-[58px] px-3 rounded-t-md border-b-[1px] border-[#E0E4E8] bg-main-gray'}>
            <FormicaInput value={search} onChange={(e) => setSearch(e.currentTarget.value)} placeholder={LanguageUtil.get({ id: 'common.input.placeholder.search', defaultMessage: 'Search' })}></FormicaInput>
          </div>
          {getItem({ label: 'All', value: '__*all*__' }, -1)}
          <div className={'flex flex-col overflow-y-scroll w-full h-full items-start justify-start min-h-[162px]'}>{getItems()}</div>
          <div
            className={`flex shrink-0 rounded-b-md w-full items-center justify-end px-3 text-f-purple text-sm min-h-10 h-10 border-t-[1px] border-[#E0E4E8] bg-main-gray cursor-pointer`}
            onClick={() => {
              props.apply();
              ref.current?.hide();
            }}
          >
            {LanguageUtil.get({ id: 'common.label.apply', defaultMessage: 'Apply' })}
          </div>
        </div>
      </OverlayPanel>
    </div>
  );
}

interface Props {
  items: FormicaSelectBoxItem[];
  selectedItems: FormicaSelectBoxItem[];
  onChangeSelectedItems: (selectedItems: FormicaSelectBoxItem[] | undefined) => void;
  apply: () => void;
  containerNode?: (onClick: (event: React.MouseEvent) => void) => ReactNode;
}

export default TableColumnPreferencesComponent;
